<!-- Search Bar -->
<div class="sidebar-search" *ngIf="!AppConfig.navCollapsed">
	<div class="search-wrapper">
		<span class="material-symbols-outlined search-icon">search</span>
		<input type="text" 
			class="search-input" 
			placeholder="{{'sidenav.pesquisaMenu' | translate}}" 
			name='filtro'
			(keyup)="applyFilter(filtro);" 
			[(ngModel)]="filtro">
		<span class="material-symbols-outlined clear-icon" 
			*ngIf="filtro" 
			(click)="clearFilter()">
			close
		</span>
	</div>
</div>

<!-- Menu Navigation -->
<ul class="nav MenuPrincipal modern-menu" myAccordionNav myAppendSubmenuIcon myHighlightActiveItems>
	<li *ngFor="let menu of menus; let i = index" 
		[ngClass]="{'hasSubMenu' : menu.hasSubMenu, 'menu-divider': shouldShowDivider(i)}" 
		id="{{menu.nome}}">
		
		<!-- Menu sem rota e sem submenu -->
		<a *ngIf="!menu.rota && !menu.hasSubMenu" class="menu-item">
			<span class="material-symbols-outlined nav-icon">{{menu.icone}}</span>
			<span class="nav-text">{{menu.nome | translate}}</span>
		</a>
		
		<!-- Menu com rota e sem submenu -->
		<a *ngIf="menu.rota && !menu.hasSubMenu" 
			[routerLink]="menu.rota" 
			[ngClass]="{'active-nav' : activeNav(menu.rota)}"
			class="menu-item">
			<span class="material-symbols-outlined nav-icon">{{menu.icone}}</span>
			<span class="nav-text">{{menu.nome | translate}}</span>
		</a>
		
		<!-- Menu com ação e sem submenu -->
		<a *ngIf="menu.acao && !menu.hasSubMenu" 
			(click)="menu.acao()"
			class="menu-item">
			<span class="material-symbols-outlined nav-icon">{{menu.icone}}</span>
			<span class="nav-text">{{menu.nome | translate}}</span>
		</a>
		
		<!-- Menu com submenu -->
		<a *ngIf="menu.hasSubMenu" class="menu-item has-submenu">
			<span class="material-symbols-outlined nav-icon">{{menu.icone}}</span>
			<span class="nav-text">{{menu.nome | translate}}</span>
			<span class="material-symbols-outlined icon-has-ul">expand_more</span>
		</a>
		
		<!-- Submenu -->
		<ul *ngIf="menu.hasSubMenu" class="submenu">
			<li *ngFor="let subMenu of menu.subMenus">
				<a [routerLink]="subMenu.rota" 
					*ngIf="subMenu.rota" 
					[ngClass]="{'active-nav' : activeNav(subMenu.rota)}"
					[attr.id]="getSubmenuAnchorId(subMenu)"
					class="submenu-item">
					<span class="material-symbols-outlined nav-icon">{{subMenu.icone}}</span>
					<span>{{subMenu.nome | translate}}</span>
				</a>
				<a (click)="subMenu.acao()" 
					*ngIf="subMenu.acao"
					class="submenu-item">
					<span class="material-symbols-outlined nav-icon">{{subMenu.icone}}</span>
					<span>{{subMenu.nome | translate}}</span>
				</a>
			</li>
		</ul>
	</li>
</ul>